<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" action="" @submit.prevent="submit">
                    <!-- Title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{trans.managed_title}}<span class="required-star"></span>
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control" 
                                maxlength="50"
                                type="text"
                                v-model="title">
                            <small class="form-text text-muted">
                                {{ trans.title_50_characters }}
                            </small>
                            <!-- error -->
                            <span
                                class="text-danger"
                                v-if="errors && errors.title"
                            >
                                {{ errors.title[0] }}
                            </span>
                        </div>
                    </div>

                    <!-- Link title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{trans.link_title}}</label>
                        <div class="col-sm-8">
                            <input class="form-control" 
                                maxlength="20" 
                                type="text" 
                                v-model="link_title">
                            <small class="form-text text-muted">
                                {{ trans.help_text.title }}
                            </small>
                            <!-- error -->
                            <span class="text-danger"
                                v-if="errors && errors.link_title"
                            >
                                {{ errors.link_title[0] }}
                            </span>
                        </div>
                    </div>

                    <!-- Subtitle -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{trans.sub_title}}</label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                maxlength="25"
                                type="text" 
                                v-model="sub_title">
                            <small class="form-text text-muted">
                                {{ trans.help_text.sub_title }}
                            </small>
                            <!-- error -->
                            <span class="text-danger"
                                v-if="errors && errors.sub_title"
                            >
                                {{ errors.sub_title[0] }}
                            </span>
                        </div>
                    </div>

                    <!-- Icon -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{trans.icon}}</label>
                        <div class="col-sm-8">
                            <label for="iconFile" role="button">
                                <img
                                    class="icon-size-100"
                                    id="preview-icon"
                                    ref="icon"
                                    style="width: 50px; height: 50px;"
                                    :src="bannerData ? bannerData.icon_url : '/img/no-image.jpg'"
                                >
                            </label>
                            <span class="align-top text-danger"
                                type="button"
                                @click="removeIcon()"
                                v-if="icon"
                            >
                                <i class="fas fa-minus-circle fa-lg"></i>
                            </span>
                            <input class="form-control-file d-none" 
                                id="iconFile"
                                type="file"
                                accept=".jpeg, .png, .jpg"
                                @change="uploadIcon">
                            <small class="form-text text-muted">
                                {{ trans.help_text.icon }}
                            </small>
                            <!-- error -->
                            <span class="form-text text-danger"
                                v-if="errors && errors.icon"
                            >
                                {{ errors.icon[0] }}
                            </span>
                        </div>
                    </div>

                    <!-- Image -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{trans.image}}</label>
                        <div class="col-sm-8">
                            <label for="backgroundImageFile" role="button">
                                <img class="icon-size-100"
                                    id="preview-background-image"
                                    ref="backgroundImage"
                                    style="width: 400px"
                                    :src="bannerData ? bannerData.background_image_url :'/img/no-image-banner.png'">
                            </label>
                            <span class="align-top text-danger"
                                type="button"
                                @click="removeBackgroundImage()"
                                v-if="background_image">
                                <i class="fas fa-minus-circle fa-lg"></i>
                            </span>
                            <input class="form-control-file d-none"
                                id="backgroundImageFile"
                                type="file"
                                accept=".jpeg, .png, .jpg"
                                @change="uploadBackgroundImage">
                            <small class="form-text text-muted">
                                {{ trans.help_text.background_image }}
                            </small>
                            <!-- error -->
                            <span class="form-text text-danger"
                                v-if="errors && errors.background_image"
                            >
                                {{ errors.background_image[0] }}
                            </span>
                        </div>
                    </div>

                    <!-- color 1 -->
                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">{{trans.color_1}}</label>
                        <div class="col-sm-8">
                            <input type="color" class="form-control form-control-lg w-25" v-model="color_1">
                            <small class="form-text text-muted">
                                {{ trans.help_text.color }}
                            </small>
                        </div>
                    </div>

                    <!-- color 2 -->
                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">{{trans.color_2}}</label>
                        <div class="col-sm-8">
                            <input type="color" class="form-control form-control-lg w-25" v-model="color_2">
                            <small class="form-text text-muted">
                                {{ trans.help_text.color }}
                            </small>
                        </div>
                    </div>

                    <!-- link -->
                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">
                            {{trans.link}}<span class="required-star"></span>
                        </label>
                        <div class="col-sm-8">
                            <div class="form-check form-check-inline"
                                v-for="linkType, linkVal in trans.type"
                                :key="linkVal"
                            >
                                <input class="form-check-input" 
                                    type="radio"
                                    v-model="selectLinkType"
                                    :value="linkVal">
                                <label class="form-check-label">{{linkType}}</label>
                            </div>
                            <!-- error -->
                            <span
                                class="form-text text-danger"
                                v-if="errors && errors.type"
                            >
                                {{ errors.type[0] }}
                            </span>

                            <input
                                v-if="selectLinkType == 1"
                                type="text"
                                class="form-control mt-2"
                                v-model="link">
                            <small class="form-text text-muted">
                                {{ trans.help_text.link }}
                            </small>
                            <!-- error -->
                            <span
                                class="form-text text-danger"
                                v-if="errors && errors.link"
                            >
                                {{ errors.link[0] }}
                            </span>
                        </div>
                    </div>
                </form>
                <!-- button submit -->
                <button
                    class="btn btn-primary w-25 center mb-4 mt-4 float-right submit-btn"
                    :disabled="isDisabled"
                >
                    {{ bannerData ? trans.btn.update : trans.btn.create }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

        formAction: {
            type: String,
            required: true
        },

        trans: {
            type: Object,
            required: true,
        },

        isEdit: {
            type: Boolean,
            default: false,
        },

        formBanner: {
            type: String,
            require: true,
        },

        bannerData: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            title: "",
            link_title: "",
            sub_title: "",
            icon: null,
            background_image: null,
            color_1: "#ab0196",
            color_2: "#0e00e0",
            selectLinkType: 1,
            link: "",
            remove_background_image: false,
            remove_icon: false,
            errors: {},
            isDisabled: false,
        };
    },
    
    methods: {
        submit() {
            this.isDisabled = true;
            axios.post( this.formAction, this.prepareFormData(), {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then( (response) => {
                location.href = '/banners'
            })
            .catch( (error) => {
                this.isDisabled = false;
                this.errors = error.response.data.errors;
            })
        },

        prepareFormData() {
            let formData = new FormData();
            formData.append("title", this.title);
            formData.append("sub_title", this.sub_title);
            formData.append("link_title", this.link_title);            
            formData.append("colors[]", this.color_1 ?? "");
            formData.append("colors[]", this.color_2 ?? "");
            formData.append("type", this.selectLinkType);
            formData.append("link", this.link);

            if (this.background_image instanceof File) {
                formData.append("background_image", this.background_image);
            }

            if (this.icon instanceof File) {
                formData.append("icon", this.icon);
            }

            if (this.isEdit) {
                formData.append('remove_background_image', this.remove_background_image);
                formData.append('remove_icon', this.remove_icon);
                formData.append("_method", "PUT");
            }

            return formData;
        },

        fetch() {
            this.title = this.bannerData.title;
            this.sub_title = this.bannerData.sub_title;
            this.link_title = this.bannerData.link_title;
            this.background_image = this.bannerData.background_image;
            this.icon = this.bannerData.icon;
            this.color_1 = this.bannerData.colors[0];
            this.color_2 = this.bannerData.colors[1];
            this.link = this.bannerData.link;
            this.selectLinkType = this.bannerData.type;
        },

        uploadBackgroundImage(e) {
            const file = e.target.files[0];

            if (!file || !file.type.match(/.(jpg|jpeg|png)$/i)) return;

            let previewImage = document.getElementById("preview-background-image")
            previewImage.src = URL.createObjectURL(file);
            this.background_image = file;
            this.remove_background_image = false;
        },

        removeBackgroundImage() {
            this.$refs.backgroundImage.src = "/img/no-image.jpg";
            this.background_image = null;

            if (this.isEdit) {
                this.remove_background_image = true;
            }
        },

        uploadIcon(e) {
            const file = e.target.files[0];

            if (!file || !file.type.match(/.(jpg|jpeg|png)$/i)) return;

            let previewIcon = document.getElementById("preview-icon");
            previewIcon.src = URL.createObjectURL(file);
            this.icon = file;
            this.remove_icon = false;

        },

        removeIcon() {
            this.$refs.icon.src = "/img/no-image.jpg";
            this.icon = null;
            if(this.isEdit) {
                this.remove_icon = true;
            }
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                        this.disabled = true;
                        let formLanguages = document.querySelectorAll(".tab-content form");
                        formLanguages.forEach(function (form) {
                            var formData = new FormData(form);
                            axios.post(form.action, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                        });
                    });
                }
            }
        },
    },

    watch: {
        'selectLinkType': function() {
            if (this.selectLinkType == 2) {
                this.link = '';
            }
        }
    },
    
    created() {
        if (this.isEdit) {
            this.fetch();
        }
    },
    mounted() {
        this.clickSubmitBtn();
    },
}
</script>